import { Port } from './port';
import { ShippingLine } from './shipping-line';
import { DurationRange } from './duration-range';
import { RouteInterface } from '../interfaces/api';

export class Route implements RouteInterface {

    id: number;

    duration: DurationRange;

    name: string;

    shipping_lines: ShippingLine[];

    ports: Port[];

    durationFormatted(): string {
        if (this.duration === undefined) return '';
        return this.duration.durationFormatted();
    }

    getDestinationPort(): Port {
        let total: number = this.ports !== undefined ? this.ports.length : 0;
        if (total > 1)
            return this.ports[total - 1];
    }

    getDeparturePort(): Port {
        if (this.ports !== undefined && this.ports.length > 0)
            return this.ports[0];
    }

    static createFromObject(object: any): Route {
        let route: Route = new Route();
        if (object.id !== undefined)                route.id = object.id;
        if (object.name !== undefined)              route.name = object.name;
        if (object.shipping_lines !== undefined)    route.shipping_lines = ShippingLine.createFromObjects(object.shipping_lines);
        if (object.ports !== undefined)             route.ports = Port.createFromObjects(object.ports);
        if (object.duration !== undefined)          route.duration = DurationRange.createFromObject(object.duration);
        return route;
    }

    static createFromObjects(routes: any[]): Route[] {
        let objects: Route[] = [];
        for (let route of routes) {
            objects.push(Route.createFromObject(route));
        }
        return objects;
    }
}



// WEBPACK FOOTER //
// ./src/entities/route.ts